export default "__VITE_ASSET__B053_oPq__"